import { createContext, useContext, useEffect, useState } from "react";
import Invitation, {
  InvitationResponseData,
} from "../../core/models/Invitation";
import NetworkingServiceError from "../../core/services/network/NetworkServiceError";
import appConfig from "../../util/appConfig";

// This context allows the app to get the Invitations information

export type InvitationError = NetworkingServiceError;

// Create type
export type InvitationsDataType = {
  invitationsResponseData?: InvitationResponseData;
  setInvitationsResponseData: (responseData?: InvitationResponseData) => void;
  selectedInvitation?: Invitation;
  setSelectedInvitation: (invitation?: Invitation) => void;
  invitationsLoading: boolean;
  setInvitationsLoading: (isLoading: boolean) => void;
  invitationsError: InvitationError | undefined;
  setInvitationsError: (error?: InvitationError) => void;
};

// Create context for type
// @ts-ignore
export const InvitationsDataContext = createContext<InvitationsDataType>();

//Create provider of the context
export const InvitationsDataProvider = ({ children }: any) => {
  const [selectedInvitation, setSelectedInvitation] = useState<Invitation>();
  const [invitationsResponseData, setInvitationsResponseData] =
    useState<InvitationResponseData>();
  const [invitationsLoading, setInvitationsLoading] = useState<boolean>(false);
  const [invitationsError, setInvitationsError] = useState<InvitationError>();

  const value = {
    invitationsResponseData,
    setInvitationsResponseData,
    selectedInvitation,
    setSelectedInvitation,
    invitationsLoading,
    setInvitationsLoading,
    invitationsError,
    setInvitationsError,
  };
  useEffect(() => {
    if (appConfig.debugInvitation && selectedInvitation)
      console.debug("[Invitations][SelectedInvitation] ", selectedInvitation);
  }, [selectedInvitation]);

  useEffect(() => {
    if (appConfig.debugInvitation && invitationsResponseData)
      console.debug(
        "[Invitations][InvitationsResponseData] ",
        invitationsResponseData
      );
  }, [invitationsResponseData]);

  useEffect(() => {
    if (appConfig.debugInvitation && invitationsLoading)
      console.debug("[Invitations][InvitationsLoading] ", invitationsLoading);
  }, [invitationsLoading]);

  useEffect(() => {
    if (appConfig.debugInvitation && invitationsError)
      console.warn(
        "[Invitations][Error] ",
        invitationsError?.userMessage(),
        invitationsError?.debugMessage()
      );
  }, [invitationsError]);
  return (
    <InvitationsDataContext.Provider value={value}>
      {children}
    </InvitationsDataContext.Provider>
  );
};

export const useInvitationsContext = () => useContext(InvitationsDataContext);
